"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUuid = isUuid;
function isUuid(value) {
  return /^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i.test(value);
}
//# sourceMappingURL=uuid.js.map